import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "../../app/store";
import { useAppSelector } from "../../app/hooks";
import { CAN_LOAD_ALL_TAUS } from "../surface/windowUtils";

interface PlaybackSlice
{
    playbackSpeed: number;
    isPlaying: boolean;
    ongoingFetchesCount: number;
    hasSlowConnection: boolean;
}

const initialState: PlaybackSlice = {
    playbackSpeed: CAN_LOAD_ALL_TAUS ? 1 : 4,
    isPlaying: false,
    ongoingFetchesCount: 0,
    hasSlowConnection: false,
};

export const playbackSlice = createSlice( {
    name: "playback",
    initialState,
    reducers: {
        setPlaybackSpeed: ( state, action: PayloadAction<number> ) =>
        {
            state.playbackSpeed = action.payload;
        },
        setIsPlaying: ( state, action: PayloadAction<boolean> ) =>
        {
            state.isPlaying = action.payload;
        },
        incrementOngoingFetches: ( state ) =>
        {
            state.ongoingFetchesCount += 1;
        },
        decrementOngoingFetches: ( state ) =>
        {
            state.ongoingFetchesCount -= 1;
        },
        setHasSlowConnection: ( state )=>
        {
            state.hasSlowConnection = true;
        },
    },
} );

export const { setPlaybackSpeed, setIsPlaying, incrementOngoingFetches, decrementOngoingFetches, setHasSlowConnection } = playbackSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const selectPlaybackSpeed = ( state: RootState ) => state.playback.playbackSpeed;
export const selectIsPlaying = ( state: RootState ) => state.playback.isPlaying;
export const selectOngoingFetches = ( state: RootState ) => state.playback.ongoingFetchesCount > 0;

//this variable is set when we need to lower the playback speed because the user does not have the desired tau yet.
//once set, it does not reset until the user refreshes the page
export const selectSlowConnection = ( state: RootState ) => state.playback.hasSlowConnection;

export const usePlaybackSpeed = () => useAppSelector( selectPlaybackSpeed );
export const useIsPlaying = () => useAppSelector( selectIsPlaying );
export const useHasOngoingFetches = () => useAppSelector( selectOngoingFetches );
export const useHasSlowConnection = () => useAppSelector( selectSlowConnection );

export default playbackSlice.reducer;
